import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  RS_DATE_FORMAT_CONTEXT,
  RS_DATE_FORMAT_MAP_CONTEXT,
  RS_SKIP_DATE_FORMATTING_CONTEXT,
  RsDateFormatContext,
  RsDateFormatMapContext
} from './request-date-formatter.tokens';
import { rsRecursiveDateFormatter } from './request-date-formatter';


function trimEmptyHttpParams(params: Object): {} {
  const httpParams: Record<string, unknown> = {};

  Object.entries(params)
    .forEach(([key, value]): void => {
      switch (Object.prototype.toString.call(value)) {

        case '[object Array]':
          if ((value as []).length) {
            httpParams[key] = value;
          }
          break;

        case '[object Object]':
          if (Object.entries(value as object).length) {
            httpParams[key] = value;
          }
          break;

        default:
          // Only exclude null, undefined, and empty strings
          if (value !== null && value !== undefined && value !== '') {
            httpParams[key] = value;
          }
          break;
      }
    });

  return httpParams;
}

function rsTrimAndFormatRequestParams(
    params: Object,
    format: RsDateFormatContext,
    formatMap: RsDateFormatMapContext
): {} {
  const trimParams = trimEmptyHttpParams(params);
  const formatedQueryParams = rsRecursiveDateFormatter(trimParams, format, formatMap);

  return formatedQueryParams
}

@Injectable()
export class RsRequestParamsFormatterInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip formatting if explicitly requested
    if (request.context.get(RS_SKIP_DATE_FORMATTING_CONTEXT)) {
      return next.handle(request);
    }

    let modifiedRequest = request;

    // Get date formatting options from context
    const format = request.context.get(RS_DATE_FORMAT_CONTEXT);
    const formatMap = request.context.get(RS_DATE_FORMAT_MAP_CONTEXT);

    // Handle request body
    if (request.body instanceof Object && !(request.body instanceof FormData)) {
      const formattedBody = rsTrimAndFormatRequestParams(request.body, format, formatMap);
      modifiedRequest = modifiedRequest.clone({ body: formattedBody });
    }

    // Handle query parameters
    if (request.params && request.params.keys().length > 0) {
      let httpParams = new HttpParams();

      const paramsObject: Record<string, unknown> = {};

      request.params.keys().forEach(key => {
        const allValues = request.params.getAll(key);

        if (allValues && allValues.length > 0) {
          // If it's a single value array with double quotes (like '"2025-07-22T22:00:00.000Z"'), clean it
          const cleaned = allValues.map(value => {
            return typeof value === 'string' && /^".*"$/.test(value)
              ? value.slice(1, -1) // remove surrounding quotes
              : value;
          });

          // Assign either a single value or array
          paramsObject[key] = cleaned.length === 1 ? cleaned[0] : cleaned;
        }
      });

      // Use the format and formatMap from context
      const formatedFilters = rsTrimAndFormatRequestParams(paramsObject, format, formatMap);

      Object.entries(formatedFilters).forEach(([key, value]) => {
        httpParams = httpParams.set(key, (value as string | number | boolean).toString());
      });

      modifiedRequest = modifiedRequest.clone({ params: httpParams });
    }

    return next.handle(modifiedRequest);
  }
}